// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1FxlY","label":"styles_label__mpcP4"};